import { render } from "./RansomwareChart.vue?vue&type=template&id=5d6fa194"
import script from "./RansomwareChart.vue?vue&type=script&lang=js"
export * from "./RansomwareChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__